<div class="container landing-container edit-details-page-wrapper">
    <div class="page-header">
        <h3 class="page-title">Edit Details</h3>
    </div>

    <div class="data-showcase-grid">
        <h4 class="grid-title">Personal Details</h4>
        <div class="profile-wrap">
            <img src="./assets/images/profile-avatar.png" alt="Avatar" class="user-profile">
            <button class="btn btn-outline-primary" title="Change Profile">Change Profile</button>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="data-label">First Name</label>
                <input type="text" class="form-control" value="John" placeholder="First Name">
            </div>
            <div class="col-sm-6">
                <label class="data-label">Last Name</label>
                <input type="text" class="form-control" value="Moniker" placeholder="Last Name">
            </div>
            <div class="col-sm-6">
                <label class="data-label">Email ID</label>
                <input type="text" class="form-control" value="johnmoniker@gmail.com" placeholder="Email">
            </div>
        </div>
    </div>
    <div class="data-showcase-grid">
        <h4 class="grid-title">Address Details</h4>
        <div class="row">
            <div class="col-sm-6">
                <label class="data-label">Address</label>
                <input type="text" class="form-control" value="A/234 Revent Park California" placeholder="Address">
            </div>
            <div class="col-sm-6">
                <label class="data-label">City</label>
                <input type="text" class="form-control" value="California" placeholder="City">
            </div>
            <div class="col-sm-6">
                <label class="data-label">Zip</label>
                <input type="text" class="form-control" value="548412" placeholder="Zip">
            </div>
            <div class="col-sm-6">
                <label class="data-label">Phone Number</label>
                <input type="text" class="form-control" value="98589 45123" placeholder="Phone Number">
            </div>
            <div class="col-sm-6">
                <label class="data-label">Location</label>
                <input type="text" class="form-control" value="Stepherd Park 451256">
            </div>
        </div>
    </div>
    <div class="data-showcase-grid">
        <h4 class="grid-title">Social Media</h4>
        <div class="row">
            <div class="col-sm-6">
                <label class="data-label">Instagram</label>
                <input type="text" class="form-control" value="johnmoniker12" placeholder="Instagram">
            </div>
            <div class="col-sm-6">
                <label class="data-label">TikTok</label>
                <input type="text" class="form-control" value="tiktok_johnmoniker12" placeholder="TikTok">
            </div>
            <div class="col-sm-6">
                <label class="data-label">Facebook</label>
                <input type="text" class="form-control" value="johnmoniker" placeholder="Facebook">
            </div>
        </div>
    </div>

    <div class="bottom-action">
        <div class="bottom-action-inner">
            <div class="btn-grps">
                <button class="btn btn-primary" title="Save Details">Save Details</button>
            </div>
        </div>
    </div>
</div>